import { render } from "./KurulumPenceresi.vue?vue&type=template&id=2d90695a"
import script from "./KurulumPenceresi.vue?vue&type=script&lang=js"
export * from "./KurulumPenceresi.vue?vue&type=script&lang=js"

import "./KurulumPenceresi.vue?vue&type=style&index=0&id=2d90695a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__